document.addEventListener("DOMContentLoaded", function (event) {
  var iecSiteId = '698';
  var iecSiteKey = '5dd28cedabe37d231e872730f40b32f3';
  var iecUrl = 'https://share.iequalchange.com/public/api/donations/livetotal?logo=1';

  function loadXMLDoc() {
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState == XMLHttpRequest.DONE) {
        if (xmlhttp.status == 200) {
          var data = JSON.parse(xmlhttp.response);

          if (iecDonation) {
            var formattedDonation = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0
            }).format(data.donation);
            
            iecDonation.innerHTML = formattedDonation;
          }

          if (iecImage) {
            iecImage.src = data.iec_logo;
          }

          iecContainer.style.display = "block";
        } else {
          console.error('iec.counter.error:' + xmlhttp.status, xmlhttp);
        }
      }
    };
    xmlhttp.open("GET", iecUrl, true);
    var base64Credentials = btoa(iecSiteId + ":" + iecSiteKey);
    xmlhttp.setRequestHeader("Authorization", "Basic " + base64Credentials);
    xmlhttp.setRequestHeader("Accept", "*/*");
    xmlhttp.send();
  }

  var iecContainer = document.getElementById("iec-container");
  var iecDonation = document.getElementById("iec-donation");
  var iecImage = document.getElementById("iec-image");

  if (iecDonation) {
    if (iecContainer) {
      iecContainer.style.display = "none";
    }
    loadXMLDoc();
  } else {
    console.error("iec.counter - HTML tag not found!");
  }
});